function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".il_svg__cls-2{fill:#0038b8}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#f0f0f0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "il_svg__cls-2",
  d: "M2.86 3h14.28a10.3 10.3 0 00-2.8-2H5.66a10.3 10.3 0 00-2.8 2zM2.86 17a10.3 10.3 0 002.8 2h8.68a10.3 10.3 0 002.8-2zM13.87 10l1-1.45 1-1.55h-4l-1-1.55L10 4.2l-.83 1.25L8.13 7h-4l1 1.55 1 1.45-1 1.45-1 1.55h4l1 1.55.87 1.25.83-1.25 1-1.55h4l-1-1.55zM14 8l-.73 1.1-.73-1.1zm-1.33 2l-1.34 2H8.67l-1.34-2 1.34-2h2.66zM10 6l.67 1H9.33zM6 8h1.46l-.73 1.1zm0 4l.73-1.1.73 1.1zm4 2l-.67-1h1.34zm2.54-2l.73-1.1L14 12z"
});

function SvgIl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "il_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojMDAzOGI4O308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMi44NiwzSDE3LjE0YTEwLjMsMTAuMywwLDAsMC0yLjgtMkg1LjY2QTEwLjMsMTAuMywwLDAsMCwyLjg2LDNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMi44NiwxN2ExMC4zLDEwLjMsMCwwLDAsMi44LDJoOC42OGExMC4zLDEwLjMsMCwwLDAsMi44LTJaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTMuODcsMTBsMS0xLjQ1LDEtMS41NWgtNGwtMS0xLjU1TDEwLDQuMiw5LjE3LDUuNDUsOC4xMyw3aC00bDEsMS41NSwxLDEuNDUtMSwxLjQ1TDQuMTMsMTNoNGwxLDEuNTVMMTAsMTUuOGwuODMtMS4yNSwxLTEuNTVoNGwtMS0xLjU1Wk0xNCw4bC0uNzMsMS4xTDEyLjU0LDhabS0xLjMzLDItMS4zNCwySDguNjdMNy4zMywxMCw4LjY3LDhoMi42NlpNMTAsNmwuNjcsMUg5LjMzWk02LDhINy40Nkw2LjczLDkuMVptMCw0LC43My0xLjFMNy40NiwxMlptNCwyLS42Ny0xaDEuMzRabTIuNTQtMiwuNzMtMS4xTDE0LDEyWiIvPjwvc3ZnPg==";
export { SvgIl as ReactComponent };